module.exports = __webpack_public_path__ + "static/media/undraw_all_the_data_h4ki.0e78e960.png";